module.exports = __webpack_public_path__ + "static/media/arrow-down.557d74ed.svg";